import type { RealtimeEvent } from "@luckymenu/core";
import { useEffect, useSyncExternalStore } from "react";
import type { RealtimeClient, RealtimeStatus } from "./client";

/** The client's status, re-rendering on change: the offline banner reads `offline`. */
export function useRealtimeStatus(client: RealtimeClient): RealtimeStatus {
	return useSyncExternalStore(
		(listener) => client.subscribe(listener),
		() => client.getStatus(),
		() => client.getStatus(),
	);
}

/** Calls `listener` for each event while mounted, such as for the new-order alert. */
export function useRealtimeEvent(
	client: RealtimeClient,
	listener: (event: RealtimeEvent) => void,
): void {
	useEffect(() => client.onEvent(listener), [client, listener]);
}
